import { css } from "@emotion/css";
import { useState } from "react";

import { NavigationTitle } from "./NavigationTitle";
import { Text } from "../../../foundations/typography/Text";

import { navigationStyles } from "./NavigationSection";
import { GhostButton } from "../../button/GhostButton";
import { GhostIconButton } from "../../button/GhostIconButton";

type Props = {
  title?: string | null;
  sectionTitle?: string;
  isCollapsible?: boolean;
  isScrollable?: boolean;
  children: React.ReactNode;
  testID?: string;
  className?: string;
};

export function NavigationMenu(props: Props) {
  const {
    isCollapsible,
    isScrollable,
    testID,
    title,
    sectionTitle,
    children,
    className,
  } = props;
  const [isOpen, setIsOpen] = useState(!isCollapsible);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={className}>
      {sectionTitle && (
        <NavigationTitle isSection style="global/heading-small">
          {sectionTitle}
        </NavigationTitle>
      )}
      <section
        className={navigationStyles}
        style={isScrollable ? { overflowY: "auto", height: "100%" } : {}}
      >
        {isCollapsible && (
          <div className={styles.title}>
            <GhostButton
              testID={testID}
              iconSize="space-5"
              iconColor="icon-weak"
              leftIcon={isOpen ? "arrow_drop_down" : "arrow_right"}
              onPress={handleClick}
            >
              <Text style="global/heading-small">{title}</Text>
            </GhostButton>
            <GhostIconButton icon="more_horiz" />
          </div>
        )}
        {isOpen && <div className={styles.wrapper}>{children}</div>}
      </section>
    </div>
  );
}

const styles = {
  sectionTitle: css({
    display: "flex",
    alignItems: "center",
    paddingLeft: "var(--space-5)",
    paddingRight: "var(--space-3)",
    height: "var(--space-10)",
  }),
  title: css({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxSizing: "border-box",
    height: "var(--space-10)",
    marginBottom: "var(--space-1-5)",
  }),
  wrapper: css({
    display: "flex",
    flexDirection: "column",
  }),
};
